import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BagItemDetails from "./BagItemDetails"

const Engagement = (props) => {
    const {bagItem} = props;

    const data = useStaticQuery(graphql`
      query HeaderEngagementQuery {
        shopifyProducts: allShopifyProduct {
          nodes { handle shopifyId }
        }
        ringContents : allContentfulEngagementRing {
          nodes {
            slug
            title
          }
        }
      }
    `)
    let items;
    let quantity;
    let lineItemIds = [];

    if (!Array.isArray(bagItem[0])) {
      items = bagItem;
      quantity = 1;
      bagItem.forEach((single) => lineItemIds.push(single.lineItemId))
    } else {
      items = bagItem[0];
      quantity = bagItem.length;
      let allItems = [];
      bagItem.forEach((set) => allItems.push(...set));
      allItems.forEach((single) => lineItemIds.push(single.lineItemId))
    }

    let diamond = items?.find((item) => !item.handle.toLowerCase().includes("band"));
    let band = items?.find((item) => item.handle.toLowerCase().includes("band"));
    const styleName =
      items &&
      items[0].customAttributes
        .find((custom) => custom.key === "Set")
        .value.replace(/[0-9.]/g, "");
    const content = data.ringContents.nodes.find((content) => content.title.trim() === styleName.trim())
    const price = parseInt(diamond?.price.amount) + parseInt(band.price.amount)
    const shape = diamond?.handle.split("-")[0] || undefined;
    const options = items && [
      ...diamond.selectedOptions,
      ...band.selectedOptions,
    ];

    const image = band?.image;
    const title = styleName;
    const customAttributes = band?.customAttributes;
    const currencyCode = diamond?.currencyCode;
    const discountAmount = diamond?.discountAmount + band?.discountAmount;

    const bagProps = {
      image,
      title,
      price,
      currencyCode,
      customAttributes,
      lineItemIds,
      options,
      quantity,
      shape,
      items,
      discountAmount,
      allProducts: data.shopifyProducts.nodes,
      content
    }

    return (
      <React.Fragment>
        <BagItemDetails {...bagProps} engagement/>
      </React.Fragment>
    )
}

export default Engagement
